module.exports = __webpack_public_path__ + "static/media/Hair_3.3a2ca9df.svg";